module.exports = __webpack_public_path__ + "img/right_tag.782254d4.png";